/**
 * Normalizes a route path for side-menu comparison (leading slash, no trailing slash).
 */
export function normalizeSideMenuRoutePath(path: string): string {
  const normalized =
    path.split('?')[0]?.split('#')[0]?.replace(/\/$/, '') ?? '';

  return normalized.startsWith('/') ? normalized : `/${normalized}`;
}

function routePathMatchesUrl(
  normalizedUrl: string,
  normalizedPath: string
): boolean {
  return (
    normalizedUrl === normalizedPath ||
    normalizedUrl.startsWith(`${normalizedPath}/`)
  );
}

/**
 * Returns true when the menu item path is the longest prefix match among sibling
 * routes in the same category (avoids `/company` staying active on `/company/1/team`).
 */
export function isSideMenuItemRouteActive(
  currentUrl: string,
  itemPath: string,
  siblingPaths: string[]
): boolean {
  const normalizedUrl = normalizeSideMenuRoutePath(currentUrl);
  const normalizedItem = normalizeSideMenuRoutePath(itemPath);
  const pathsToCompare =
    siblingPaths.length > 0
      ? siblingPaths.map((path) => normalizeSideMenuRoutePath(path))
      : [normalizedItem];

  const matchingPaths = pathsToCompare
    .filter((path) => routePathMatchesUrl(normalizedUrl, path))
    .sort((left, right) => right.length - left.length);

  return matchingPaths[0] === normalizedItem;
}
